import { Stack } from '@mui/material';
import { ReactComponent as SplitIcon } from 'new/components/icons/fi-sr-split.svg';
import { ReactComponent as NexsetsIcon } from 'new/components/icons/nexsetsOutline.svg';
import React from 'react';
import { ChipWithCopy } from '../ChipWithCopy';
import styles from './ConnectionTypeChip.module.scss';

type Props = {
  /**
   * The icon to display. Can be a React node or a string (URL).
   */
  icon?: React.ReactNode | string;
  label?: string | React.ReactNode;
  style?: any;
  isNexset?: boolean;
  isSplitter?: boolean;
  iconOnly?: boolean;
  /**
   * The ID of the resource.
   * If provided, a copyable chip will be displayed.
   */
  resourceId?: string;
};

const Icon = ({ icon, label, isNexset, isSplitter }: Props) => {
  if (isSplitter) {
    return <SplitIcon className={styles.icon} fill={'currentColor'} />;
  }

  if (isNexset) {
    return <NexsetsIcon className={styles.icon} fill={'currentColor'} />;
  }

  if (typeof icon === 'string') {
    const altLabel = typeof label === 'string' ? label : '';
    return <img className={styles.icon} src={icon} alt={altLabel} />;
  }

  if (!!icon) return icon;

  return null;
};

export function ConnectionTypeChip(props: Props) {
  const {
    icon,
    label,
    style,
    isNexset = false,
    iconOnly = false,
    resourceId = null,
    isSplitter = false,
  } = props;
  const dataSetLabel = 'Nexset';

  const labelView = iconOnly ? null : (
    <span className={styles.label}>{!isNexset && !iconOnly ? label : dataSetLabel}</span>
  );

  if (resourceId) {
    return (
      <Stack className={styles.labelViewSecondary}>
        <Stack direction="row" alignItems="center" gap="8px">
          <Icon icon={icon} label={label} isNexset={isNexset} isSplitter={isSplitter} />
          {labelView}
        </Stack>
        <ChipWithCopy toCopy={resourceId}>ID {resourceId}</ChipWithCopy>
      </Stack>
    );
  }

  return (
    <div className={styles.labelView} style={style}>
      <Icon icon={icon} label={label} isNexset={isNexset} isSplitter={isSplitter} />
      {labelView}
    </div>
  );
}
